module.exports = __webpack_public_path__ + "img/ge.3e7dfc27.png";